"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var ModalFactory = /** @class */ (function () {
    function ModalFactory($uibModal) {
        var _this = this;
        this.$uibModal = $uibModal;
        this.show = function (templateUrl, model, successCallback, failureCallback, size, addOptions) {
            var options = {
                templateUrl: templateUrl,
                controller: 'modalController',
                controllerAs: 'vm',
                resolve: {
                    model: function () {
                        return model;
                    }
                },
                size: null
            };
            options = angular.extend(options, addOptions);
            if (size) {
                options.size = size;
            }
            var modalInstance = _this.$uibModal.open(options);
            modalInstance.result.then(function (result) {
                if (typeof successCallback === 'function') {
                    successCallback(result);
                }
            }, function (result) {
                if (typeof failureCallback === 'function') {
                    failureCallback(result);
                }
            });
            return modalInstance;
        };
        return this;
    }
    return ModalFactory;
}());
exports.ModalFactory = ModalFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwuZmFjdG9yeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1vZGFsLmZhY3RvcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBbUM7QUFFbkM7SUFtQ0ksc0JBQW1CLFNBQVM7UUFBNUIsaUJBRUM7UUFGa0IsY0FBUyxHQUFULFNBQVMsQ0FBQTtRQWxDckIsU0FBSSxHQUFHLFVBQUMsV0FBVyxFQUFFLEtBQUssRUFBRSxlQUFlLEVBQUUsZUFBZSxFQUFFLElBQUksRUFBRSxVQUFVO1lBQ2pGLElBQUksT0FBTyxHQUFHO2dCQUNWLFdBQVcsRUFBRSxXQUFXO2dCQUN4QixVQUFVLEVBQUUsaUJBQWlCO2dCQUM3QixZQUFZLEVBQUUsSUFBSTtnQkFDbEIsT0FBTyxFQUFFO29CQUNMLEtBQUssRUFBRTt3QkFDSCxPQUFPLEtBQUssQ0FBQztvQkFDakIsQ0FBQztpQkFDSjtnQkFDRCxJQUFJLEVBQUUsSUFBSTthQUNiLENBQUM7WUFFRixPQUFPLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsVUFBVSxDQUFDLENBQUM7WUFFOUMsSUFBSSxJQUFJLEVBQUU7Z0JBQ04sT0FBTyxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7YUFDdkI7WUFFRCxJQUFJLGFBQWEsR0FBRyxLQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUVqRCxhQUFhLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxVQUFDLE1BQU07Z0JBQzdCLElBQUksT0FBTyxlQUFlLEtBQUssVUFBVSxFQUFFO29CQUN2QyxlQUFlLENBQUMsTUFBTSxDQUFDLENBQUM7aUJBQzNCO1lBQ0wsQ0FBQyxFQUFFLFVBQUMsTUFBTTtnQkFDTixJQUFJLE9BQU8sZUFBZSxLQUFLLFVBQVUsRUFBRTtvQkFDdkMsZUFBZSxDQUFDLE1BQU0sQ0FBQyxDQUFDO2lCQUMzQjtZQUNMLENBQUMsQ0FBQyxDQUFDO1lBRUgsT0FBTyxhQUFhLENBQUM7UUFDekIsQ0FBQyxDQUFDO1FBR0UsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUNMLG1CQUFDO0FBQUQsQ0FBQyxBQXRDRCxJQXNDQztBQXRDWSxvQ0FBWSJ9